// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8058a409","453":"c6d4fc32","455":"a67031d4"}[chunkId] + ".chunk.js";
};